import { ManageAccounts, WarningAmber } from '@mui/icons-material';
import { IGestShellRoute, ISharedConfig } from '@shared/library';
import AlarmsManager from '@webgest/alarms-manager';
import BillingAnalyzer from '@webgest/billing-analyzer';
import GeoTool from '@webgest/geotool';
import RoutesAnalyzer from '@webgest/route-analyzer';
import { Route, Routes } from 'react-router-dom';
import config from '../../config';
import { customInterventionColumns, customInterventionEditForm } from '../../config/_custom/WFM/WfmAtena';
import { ADMIN_PANEL_PATH, HOME_PATH } from '../../static/constants';
import AdministrationPanel from './AdminTools/AdministrationPanel/AdministrationPanel';
import ToPolyline from './AdminTools/ToPolyline/ToPolyline';
import DynamicDashboard from './DevExpressDashboards/DynamicDashboard';
import GetOld from './GetOld';
import Home from './Home/Home';
import RouteGenerator from './WalkBy-DriveBy/RouteGenerator/RouteGenerator';
import InterventionManagement from './WFM/InterventionManagement/InterventionManagement';
import PlanAssignments from './WFM/PlanAssignment/PlanAssignments';
import Planning from './WFM/Planning/Planning';

/**
 * The UI of the routes: the backend decides which routes exist (the menu has their paths, case does not matter), the shell attaches to each entry
 * the page (and the icon, when it can be imported) of the key with the same path. A route of the backend that is not here has no page.
 */
export const getRoutes = (cntxConfig: ISharedConfig): Record<string, IGestShellRoute> => ({
    [HOME_PATH]: { standalone: true, element: <Home {...cntxConfig} /> },
    //NETWORK ANALYSIS
    //the dashboard reads its id from the url with react-router
    "/dynamicDashboard/:id?": { element: <Routes><Route path="/dynamicDashboard/:id?" element={<DynamicDashboard />} /></Routes> },
    "/networkAnalysis": { element: <GetOld path={`${config.api.old}/networkAnalysis`} /> },
    //MONITOR
    "/consumptionMonitor": { element: <GetOld path={`${config.api.old}/consumptionMonitor`} /> },
    "/pressuresMonitor": { element: <GetOld path={`${config.api.old}/pressuresMonitor`} /> },
    //WALK-BY/DRIVE-BY TOOLS
    "/RouteGenerator": { element: <RouteGenerator {...cntxConfig} /> },
    "/routesAnalysis": { element: <RoutesAnalyzer {...cntxConfig} /> },
    "/walkByDriveBySync": { element: <GetOld path={`${config.api.old}/walkByDriveBySync`} /> },
    "/import/*": { element: <GetOld path={`${config.api.old}/import/*`} /> },
    "/export/*": { element: <GetOld path={`${config.api.old}/export/*`} /> },
    //OPERATING TOOLS
    "/userRegistries": { element: <GetOld path={`${config.api.old}/userRegistries`} /> },
    //FIELD DATA SURVEY
    "/qualifications": { element: <GetOld path={`${config.api.old}/qualifications`} /> },//Da cambiare in /fieldDataMonitor
    //WORKFORCE MANAGEMENT (WFM)
    "/interventionManagement": { element: <InterventionManagement {...{ config: cntxConfig }} /> },
    "/InterventionManagementATENA": { element: <InterventionManagement {...{ config: cntxConfig, customInterventionEditForm, customInterventionColumns }} /> },//CUSTOMIZATION
    "/planning": { element: <Planning {...cntxConfig} /> },
    "/planAssignments": { element: <PlanAssignments {...cntxConfig} /> },
    //ADMIN TOOLS
    "/adminTools/toPolyline": { element: <ToPolyline /> },
    "/GeoTool": { element: <GeoTool {...cntxConfig} /> },
    "/alarms-manager": { icon: <WarningAmber />, element: <AlarmsManager {...cntxConfig} /> },
    "/billing-analyzer": { element: <BillingAnalyzer {...cntxConfig} /> },
    //ADMINISTRATION PANEL (an entry that the app adds to the menu for the admins only)
    [ADMIN_PANEL_PATH]: { icon: <ManageAccounts />, element: <AdministrationPanel {...cntxConfig} /> },
});
